import useCoreModelsFind from '../../../hooks/useCoreModelsFind'

export default id => useCoreModelsFind('schedulePosition', id)
